import React from 'react';
import ShareOptionsButtons from '../optionsButtons/ShareOptionsButtons';

const ShareButton = props => {
  const { getImageFromCanvasOpenDoor, getImageFromCanvasCloseDoor, getPricesInfo } = props;

  return (
    <div className="share-options open">
      <div className="share-options-title">Udostępnij</div>
      <ShareOptionsButtons
        getImageFromCanvasOpenDoor={getImageFromCanvasOpenDoor}
        getImageFromCanvasCloseDoor={getImageFromCanvasCloseDoor}
        getPricesInfo={getPricesInfo}
      />
    </div>
  );
};

export default ShareButton;
